import { render, staticRenderFns } from "./RevenueYearGraphPanel.vue?vue&type=template&id=1bf3590b&scoped=true"
import script from "./RevenueYearGraphPanel.vue?vue&type=script&lang=js"
export * from "./RevenueYearGraphPanel.vue?vue&type=script&lang=js"
import style0 from "./RevenueYearGraphPanel.vue?vue&type=style&index=0&id=1bf3590b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3590b",
  null
  
)

export default component.exports